import { useISSDetail } from '../hooks/usePhase3.js';

const s = {
  section: { marginTop: 8 },
  sectionLabel: { fontSize: 10, color: '#475569', textTransform: 'uppercase',
                  letterSpacing: 1, marginBottom: 4 },
  crewRow: { display: 'flex', alignItems: 'center', gap: 6,
             padding: '3px 0', fontSize: 11, color: '#94a3b8' },
  crewName: { color: '#e2e8f0', fontWeight: 600 },
  divider:  { borderColor: '#1e293b', margin: '8px 0' },
  liveRow:  { display: 'flex', justifyContent: 'space-between',
              fontSize: 11, marginBottom: 3 },
  label:    { color: '#64748b' },
  val:      { color: '#69FF94', fontWeight: 600 },
};

export default function ISSDetailPanel() {
  const { crew, issNow } = useISSDetail();
  if (!crew.length && !issNow) return null;

  return (
    <>
      {issNow?.iss_position && (
        <>
          <hr style={s.divider} />
          <div style={s.sectionLabel}>Live position</div>
          <div style={s.liveRow}>
            <span style={s.label}>LAT</span>
            <span style={s.val}>{parseFloat(issNow.iss_position.latitude).toFixed(2)}°</span>
          </div>
          <div style={s.liveRow}>
            <span style={s.label}>LON</span>
            <span style={s.val}>{parseFloat(issNow.iss_position.longitude).toFixed(2)}°</span>
          </div>
        </>
      )}

      {crew.length > 0 && (
        <>
          <hr style={s.divider} />
          <div style={s.sectionLabel}>Crew aboard ({crew.length})</div>
          {crew.map(p => (
            <div key={p.name} style={s.crewRow}>
              <span>👤</span>
              <span style={s.crewName}>{p.name}</span>
            </div>
          ))}
        </>
      )}
    </>
  );
}
